(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('ViewExpandedDripPreferences', [
			'globalConfig',
			ViewExpandedDripPreferencesFunction
		]);

	function ViewExpandedDripPreferencesFunction(
		globalConfig
	) {
		var viewExpandedDripPreferences = this;

		(function init() {
			angular.extend(viewExpandedDripPreferences, globalConfig);
		})();
	}
})(window.angular);